// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/comment.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/comment.proto.
 */
export const file_inventory_v1_comment: GenFile = /*@__PURE__*/
  fileDesc("ChppbnZlbnRvcnkvdjEvY29tbWVudC5wcm90bxIMaW52ZW50b3J5LnYxIlIKB0NvbW1lbnQSKAoEdGltZRgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDAoEYm9keRgCIAEoCRIPCgd1c2VyX2lkGAMgASgJQrQBChBjb20uaW52ZW50b3J5LnYxQgxDb21tZW50UHJvdG9QAVpBZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9pbnZlbnRvcnkvdjE7aW52ZW50b3J5djGiAgNJWFiqAgxJbnZlbnRvcnkuVjHKAgxJbnZlbnRvcnlcVjHiAhhJbnZlbnRvcnlcVjFcR1BCTWV0YWRhdGHqAg1JbnZlbnRvcnk6OlYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message inventory.v1.Comment
 */
export type Comment = Message<"inventory.v1.Comment"> & {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.Comment.
 * Use `create(CommentSchema)` to create a new message.
 */
export const CommentSchema: GenMessage<Comment> = /*@__PURE__*/
  messageDesc(file_inventory_v1_comment, 0);

